import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns whether the current authenticated user has at least one
 * organization_members row with mfa_enrolled = false. Used by the
 * persistent MFA banner to decide visibility.
 */
export function useMFAStatus() {
  return useQuery({
    queryKey: ["mfa-status"],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data: u } = await supabase.auth.getUser();
      if (!u?.user) return { authenticated: false, needsEnrollment: false };
      const { data, error } = await supabase
        .from("organization_members")
        .select("mfa_enrolled")
        .eq("user_id", u.user.id)
        .is("deactivated_at", null);
      if (error) return { authenticated: true, needsEnrollment: false };
      const needs = (data ?? []).some((r: { mfa_enrolled: boolean | null }) => r.mfa_enrolled !== true);
      return { authenticated: true, needsEnrollment: needs };
    },
  });
}
